import React from "react";
import { LucideIcon } from "lucide-react";

interface ProcessCardProps {
  icon: LucideIcon;
  number: number;
  title: string;
  description: string;
  isLast?: boolean;
}

export const ProcessCard: React.FC<ProcessCardProps> = ({
  icon: Icon,
  number,
  title,
  description,
  isLast = false,
}) => {
  return (
    <div className="relative flex items-start gap-6 md:gap-8">
      {/* Timeline Line and Icon */}
      <div className="relative flex flex-col items-center flex-shrink-0">
        {/* Icon Circle */}
        <div className="relative z-10 flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-gradient-to-r from-[#00A3FF] to-[#0077CC] shadow-lg shadow-[#00A3FF]/30 transition-transform duration-300 group-hover:scale-110 border-4 border-dark-bg">
          <Icon
            className="w-6 h-6 md:w-7 md:h-7 text-white"
            strokeWidth={2}
          />
        </div>

        {/* Step Number Badge */}
        <div className="absolute -top-2 -right-2 z-20 flex items-center justify-center w-7 h-7 rounded-full bg-gradient-to-r from-[#00A3FF] to-[#0077CC] border-2 border-dark-bg text-white text-xs font-bold shadow-lg">
          {number}
        </div>

        {/* Vertical Line */}
        {!isLast && (
          <div className="absolute top-16 md:top-[4.5rem] w-0.5 h-full bg-gradient-to-b from-[#00A3FF]/50 to-[#00A3FF]/10"
               style={{ height: 'calc(100% + 1.25rem)' }}>
          </div>
        )}
      </div>

      {/* Content Card */}
      <div className="group flex-1 bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 md:p-8 text-white transition-all duration-300 hover:border-white/30 hover:shadow-lg hover:shadow-[#00A3FF]/10 mb-5">
        <div className="flex items-baseline gap-2 mb-3">
          <h3 className="text-xl md:text-2xl font-bold">{title}</h3>
        </div>
        <p className="text-gray-300 leading-relaxed text-base">
          {description}
        </p>
      </div>
    </div>
  );
};
